import React, { useMemo } from 'react';
import { View, Text, FlatList, Image, Dimensions, useWindowDimensions } from 'react-native';
import { SUB_WIDGET_LIST } from '../../navigation/StackNavigator/routes';
import { useTranslation } from 'react-i18next';
import CustomPressable from '../customPressable/customPressable';
import { ImageComp } from '../Image/Image';
import { useNavigation } from '@react-navigation/native';
import { useCssStyle } from '../../customHook/getCssStyle';
import CustomFlatList from '../customFlatList';
import { getCleanUrl } from '../../utils/Helper';
import RenderHTML from 'react-native-render-html';

const MultipleSmallWidget = props => {
  const { listItemData, handleOnWidgetClick, widget } = props || {};

  const { t } = useTranslation();
  const { width } = useWindowDimensions()
  const navigation = useNavigation();
  const getStyles = useCssStyle();



  const handleListAll = () => {
    navigation.navigate(SUB_WIDGET_LIST, { listItemData, widget })
  }

  const renderItem = ({ item }) => {
    const widgetImg = getCleanUrl(item?.btnImageUrl);
    const listItemDescription = getStyles(['multipleSmallWidget_WidgetsSubTitleText']);
    return (
        <CustomPressable id={`multipleSmallWidget_WidgetsContainer`} style={getStyles(['multipleSmallWidget_WidgetsContainer'])} onPress={() => handleOnWidgetClick(item)}>

          <ImageComp
            source={widgetImg}
            style={getStyles(['multipleSmallWidget_WidgetsImg'])}
            id={`multipleSmallWidget_WidgetsImg`}
          />

          <View 
            style={getStyles(['multipleSmallWidget_WidgetsTitleContainer'])} 
            id={`multipleSmallWidget_WidgetsTitleContainer`} 
          >
            {item?.widgetTitle && 
              <Text 
                style={getStyles(['multipleSmallWidget_WidgetsTitleText'])} 
                id={`multipleSmallWidget_WidgetsTitleText`}
              >{item?.widgetTitle}</Text>}

            {item?.widgetDesc && 
              <RenderHTML 
                contentWidth={width}
                baseStyle={listItemDescription}
                source={{ html: item?.widgetDesc }}
                systemFonts={[listItemDescription.fontFamily]}
                id={`multipleSmallWidget_WidgetsSubTitleText`}
              />}
            
            {item.buttonTitle &&
              <View 
                onPress={handleOnWidgetClick} 
                style={getStyles(['multipleSmallWidget_WidgetsButtonContainer'])} 
                id={`multipleSmallWidget_WidgetsButtonContainer`}
              >
                <Text 
                  style={getStyles(['multipleSmallWidget_WidgetsButtonContainerText'])} 
                  id={`multipleSmallWidget_WidgetsButtonContainerText`}
                >{item.buttonTitle}</Text>
              </View>
            }
          </View>
        </CustomPressable>
    )
  }


  const customWidgetTitleStyle = useMemo(() => {
      const style = getStyles(['multipleSmallWidgetTitleText'])
      return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

      // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const customWidgetDescriptioneStyle = useMemo(() => {
      const style = getStyles(['multipleSmallWidgetDescriptionText'])
      return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

      // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  return (
    <View style={getStyles(['multipleSmallWidgetContainer'])} id={`multipleSmallWidgetContainer`} >

      <View style={getStyles(['multipleSmallWidgetTitleContainer'])} id={`multipleSmallWidgetTitleContainer`} >
        <View style={getStyles(['multipleSmallWidgetTitleTextContainer'])} id={`multipleSmallWidgetTitleTextContainer`}>
          {widget?.displayName && <RenderHTML
              contentWidth={width}
              baseStyle={customWidgetTitleStyle}
              source={{ html: widget?.displayName}}
              systemFonts={[customWidgetTitleStyle.fontFamily]}
              id={`multipleSmallWidgetTitleText`}
          />}
          {widget?.widgetDesc && <RenderHTML
              contentWidth={width}
              baseStyle={customWidgetDescriptioneStyle}
              source={{ html: widget?.widgetDesc}}
              systemFonts={[customWidgetDescriptioneStyle.fontFamily]}
              id={`multipleSmallWidgetDescriptionText`}
          />}
        </View>
        <CustomPressable onPress={handleListAll}>
          <Text style={getStyles(['multipleSmallWidgetViewAllTxt'])} id='multipleSmallWidgetViewAllTxt' >{t('home_page.view_all')}</Text>
        </CustomPressable>
      </View>
      
      <CustomFlatList
        data={listItemData}
        renderItem={renderItem}
        contentContainerStyle={getStyles(['multipleSmallWidget_MainWidgetsContainer'])}
        keyExtractor={item => item?.widgetId}
        horizontal
        showsHorizontalScrollIndicator={false}
        id={`multipleSmallWidget_MainWidgetsContainer`}
      />
    </View>
  );
};

export default React.memo(MultipleSmallWidget);
